import { ProgressFormDetail as AntdProgressFormDetail } from "@empglabs/backoffice-ui-kit"

const ProgressFormDetail = props => {
  return <AntdProgressFormDetail {...props} />
}

export default ProgressFormDetail
